import { atlasBackendApi } from './atlasBackendClient';
import type {
  AutopilotDashboardResponse,
  AutopilotJiraImportResponse,
  AutopilotItemContentsResponse,
  AutopilotReviewStatusResponse,
} from '../../types/autopilotDashboard';

export async function fetchAutopilotDashboard(options?: {
  signal?: AbortSignal;
  maxCommits?: number;
  maxFiles?: number;
  queueRef?: string;
}): Promise<AutopilotDashboardResponse> {
  const response = await atlasBackendApi.get<AutopilotDashboardResponse>('/api/autopilot/dashboard', {
    params: {
      max_commits: options?.maxCommits,
      max_files: options?.maxFiles,
      queue_ref: options?.queueRef,
    },
    signal: options?.signal,
  });
  return response.data;
}

export async function fetchAutopilotItemContents(
  itemId: string,
  options?: { signal?: AbortSignal; maxChars?: number }
): Promise<AutopilotItemContentsResponse> {
  const response = await atlasBackendApi.get<AutopilotItemContentsResponse>(`/api/autopilot/item/${encodeURIComponent(itemId)}/contents`, {
    params: {
      max_chars: options?.maxChars,
    },
    signal: options?.signal,
  });
  return response.data;
}

export async function setAutopilotItemReviewStatus(
  itemId: string,
  payload: { status: string; reason?: string }
): Promise<AutopilotReviewStatusResponse> {
  const response = await atlasBackendApi.post<AutopilotReviewStatusResponse>(
    `/api/autopilot/item/${encodeURIComponent(itemId)}/review-status`,
    payload
  );
  return response.data;
}

export async function importJiraReportedItems(payload?: {
  project_key?: string;
  label?: string;
  issue_type?: string;
  max_results?: number;
}): Promise<AutopilotJiraImportResponse> {
  const response = await atlasBackendApi.post<AutopilotJiraImportResponse>(
    '/api/jira/import-reported',
    {
      project_key: payload?.project_key ?? 'CAB',
      label: payload?.label ?? '',
      issue_type: payload?.issue_type ?? 'Task',
      max_results: payload?.max_results ?? 50,
    }
  );
  return response.data;
}

